/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { rpMediaQueries } from '../../core/theme'
import { numberWithSpaces } from '../../utils/number'
import { DepositIcon } from '../Icons'
import { Typography } from '../Typography'

const Container = styled.div`
  display: flex;
  padding-bottom: 4px;
  gap: 2px;
  align-items: center;

  ${rpMediaQueries.tablet} {
    padding-bottom: 8px;
  }
`

export const TotalDepositBox: FC<{ deposit: number; className?: string }> =
  observer(({ deposit, className }) => {
    return (
      <Container
        className={className}
        css={css`
          visibility: ${deposit > 0 ? 'visible' : 'hidden'};
        `}>
        <Typography
          variant="head3"
          color="white"
          as="span"
          css={css`
            line-height: 0.9;
          `}>
          {numberWithSpaces(deposit)}
        </Typography>
        <DepositIcon
          color="gold1"
          size={{
            mobile: '6px',
            tablet: '10px',
            desktop: '10px',
          }}
        />
      </Container>
    )
  })
